var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.streamManager)?_c('div',[_c('ov-video',{attrs:{"stream-manager":_vm.streamManager}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }